var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-steps--container" },
    [
      _c("team-region-member-filter-options", {
        attrs: {
          "team-region-id": _vm.teamRegionId,
          "team-member-public-userid": _vm.teamMemberFilterValue,
          "strict-team-region-filter": false,
          clearable: false,
          "show-carriers": false,
        },
        on: { changed: _vm.handleTeamRegionMemberChanged },
      }),
      _c(
        "md-field",
        [
          _c("vue-select", {
            staticClass: "select",
            attrs: {
              label: "label",
              options: _vm.sortedFieldGroupOptions,
              placeholder: "Document Type",
              searchable: _vm.$root.isDesktop,
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function (option) {
                  return [_c("span", [_vm._v(_vm._s(option.label))])]
                },
              },
            ]),
            model: {
              value: _vm.selectedDocGroup,
              callback: function ($$v) {
                _vm.selectedDocGroup = $$v
              },
              expression: "selectedDocGroup",
            },
          }),
        ],
        1
      ),
      _c(
        "md-field",
        [
          _c("md-datepicker", {
            staticClass: "filter-steps--choices filter-step-date start-date",
            attrs: {
              "data-testid": "start-date",
              "md-immediately": "",
              "md-debounce": 100,
            },
            model: {
              value: _vm.fromDate,
              callback: function ($$v) {
                _vm.fromDate = $$v
              },
              expression: "fromDate",
            },
          }),
        ],
        1
      ),
      _c(
        "md-field",
        [
          _c("md-datepicker", {
            staticClass: "filter-steps--choices filter-step-date end-date",
            attrs: {
              "data-testid": "end-date",
              "md-immediately": "",
              "md-debounce": 100,
            },
            model: {
              value: _vm.toDate,
              callback: function ($$v) {
                _vm.toDate = $$v
              },
              expression: "toDate",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }